import { colors, tokens } from "styles";
import {
  alpha,
  Avatar,
  Pagination as MUIPagination,
  PaginationItem,
} from "@mui/material";
import React from "react";
import pagLeft from "assets/images/app/pagination-left.svg";
import pagRigth from "assets/images/app/pagination-right.svg";

const Pagination = ({ count, page, handleChange, size = "medium" }) => {
  return (
    <MUIPagination
      count={count}
      variant="outlined"
      shape="rounded"
      page={page}
      size={size}
      onChange={handleChange}
      renderItem={(item) => (
        <PaginationItem
          slots={{
            previous: () => <LeftIcon />,
            next: () => <RightIcon />,
          }}
          {...item}
          sx={{
            border: "none",
            borderRadius: "49px",
            height: "fit-content",
            width: "fit-content",
            padding: 0,
          }}
        />
      )}
      sx={{
        "& .MuiPaginationItem-root:not(.MuiPaginationItem-previousNext)": {
          ...tokens.FS16FW700LH19_2B,
          borderRadius: "4px",
          backgroundColor: alpha(colors.skyBlueF6, 0.41),
          padding: "6px 11px",
          "&.Mui-selected": {
            border: `0.2px solid black`,
            backgroundColor: colors.skyBlueF6,
            color: colors.whiteFF,
          },
        },
      }}
    />
  );
};

const LeftIcon = () => {
  return (
    <Avatar
      src={pagLeft}
      variant="square"
      sx={{
        "& img": {
          objectFit: "contain",
        },
      }}
    />
  );
};
const RightIcon = () => {
  return (
    <Avatar
      src={pagRigth}
      variant="square"
      sx={{
        width: "fit-content",
        height: "100%",
        "& img": {
          objectFit: "contain",
        },
      }}
    />
  );
};

export default Pagination;
